import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4001';

const usePageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    fetch(`${API_BASE}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        path: location.pathname + location.search,
        referrer: document.referrer || '',
      }),
    }).catch(() => {});
  }, [location.pathname, location.search]);
};

export default usePageTracker;
